// import React, { useState, useEffect } from "react";

// import {
//   Button,
//   Chip,
//   Drawer,
//   FormFieldSet,
//   InfoCardNew,
//   NewTableAdv,
//   RankTable,
//   SmartTooltip,
// } from "../../../../components";
// import { mapTableRows } from "../../../../utils";
// import { formatWords2 } from "../../../../utils/stringUtils";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllLeadsStart } from "../../../../redux/slices/leads/leadsSlice";

// const AllLeads = () => {
//   const [showMergeModal, setShowMergeModal] = useState(false);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const allLeads = useSelector((state) => state?.leads.allLeads);
//   console.log("All Leads from Redux:", allLeads);
//   const columns = [
//     {
//       key: "companyName",
//       label: "Account Name",
//       minWidth: 250,
//       render: (row) => (
//         <div className="text-info cursor-pointer">
//           {row.companyName}
//           {/* {formatWords2(row.companyName)} */}
//         </div>
//       ),
//     },
//     { key: "jobTitle", label: "Job Title", width: 250 },
//     { key: "jobLocation", label: "Job Location", width: 250 },
//     {
//       key: "jobDescription",
//       label: "Job Description",
//       minWidth: 350,
//       maxWidth: 400,
//       className: "flex-1",
//       render: (row) => (
//         <div className="flex-1 flex text-info items-center gap-2">
//           {/* {row.jobDescription && typeof row.jobDescription === "string" ? (
//             <a
//               href={row.jobDescription}
//               target="_blank"
//               className="text-info"
//               rel="noreferrer"
//             > */}
//           {row.jobDescription}
//           {/* </a>
//           ) : (
//             "-"
//           )} */}
//         </div>
//       ),
//     },
//     {
//       key: "contactDetails",
//       label: "Contact Details",
//       maxWidth: 170,
//       render: (row) => (
//         <div className="flex-1 flex items-center gap-2">
//           <div className="w-fit truncate overflow-hidden whitespace-nowrap">
//             <span className="text-success">3</span>/5
//           </div>
//         </div>
//       ),
//     },
//     {
//       key: "",
//       label: "Actions",
//       width: 150,
//       render: (row) => (
//         <div className="flex items-center justify-between gap-2">
//           <SmartTooltip description={"View"} noicon>
//             <Button
//               type="icon"
//               variant="text"
//               icon="visibility"
//               size="xs"
//               color="black"
//               onClick={() => {
//                 setViewData(row);
//                 setOpenViewModal(true);
//               }}
//             />
//           </SmartTooltip>
//           <SmartTooltip description={"Edit"} noicon>
//             <Button
//               type="icon"
//               variant="text"
//               icon="edit_square"
//               size="xs"
//               color="black"
//               onClick={() => handleOpenEditModal(row.jobId, row.companyId)}
//             />
//           </SmartTooltip>
//           <SmartTooltip description={"Delete"} noicon>
//             <Button
//               type="icon"
//               variant="text"
//               icon="delete"
//               size="xs"
//               color="black"
//               onClick={() => {
//                 setDeleteLeadId(row.id);
//                 setShowDeleteAlert(true);
//               }}
//             />
//           </SmartTooltip>
//         </div>
//       ),
//     },
//   ];
//   const rows = Array.from({ length: 5 }, (_, i) => ({
//     companyName: `Company ${i + 1}`,
//     jobTitle: "Frontend Developer",
//     jobLocation: "Texas, Houston",
//     jobDescription: "https://www.domain.com",
//     contactDetails: "3/5",
//   }));
//   useEffect(() => {
//     dispatch(
//       fetchAllLeadsStart({
//         coll: "Company",
//         fil: JSON.stringify({
//           uiid: { type: "ALL_LEADS", value: "" },
//         }),
//         useAggregate: true,
//         lim: 10,
//         pg: 1,
//         onSuccess: (data) => {
//           console.log("All Leads API Data:", data);
//         },
//       })
//     );
//   }, [dispatch]);
//   const mappedRows = mapTableRows(rows, columns);
//   return (
//     <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
//       <div className="grid grid-cols-8 gap-10 px-4">
//         <InfoCardNew title="Total Accounts" value={9999} backValue={21} />
//         <InfoCardNew title="Completed Accounts" value={12} backValue={-21} />
//         <InfoCardNew title="Pending Accounts" value={7777} backValue={21} />
//         <InfoCardNew title="Total Job Details" value={12} backValue={-21} />
//         <InfoCardNew title="Total Contact Details" value={24} backValue={21} />
//         <InfoCardNew title="Valid Emails" value={12} backValue={-21} />
//         <InfoCardNew title="Invalid Emails" value={24} backValue={21} />
//         <InfoCardNew title="Yet To Validate Emails" value={12} backValue={21} />
//       </div>

//       <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
//         <div className="flex-1 overflow-hidden shadow-tableset px-2">
//           <NewTableAdv
//             columns={columns}
//             rows={mappedRows}
//             // loading={loading}
//             toolbarRight={{
//               search: true,
//               filter: true,
//               download: false,
//               add: [
//                 {
//                   component: (
//                     <div className="flex gap-3">
//                       <div className="flex justify-end items-end">
//                         <Button
//                           title="Merge Lead"
//                           icon={"cell_merge"}
//                           size="sm"
//                           onClick={() => setShowMergeModal(true)}
//                         />
//                       </div>
//                     </div>
//                   ),
//                 },
//               ],
//             }}
//           />
//         </div>
//       </div>
//       <Drawer
//         isOpen={showMergeModal}
//         title={"Select Lead"}
//         onClose={() => setShowMergeModal(false)}
//         width="w-[50%]"
//       >
//         <div className="flex flex-col gap-3">
//           <div className="grid grid-cols-2">
//             <FormFieldSet
//               type="select"
//               multiple
//               showSearch
//               title="Minimum 2 leads are required to merge"
//               placeholder="Search Lead"
//               options={[
//                 { label: "Lead 1", value: 1 },
//                 { label: "Lead 13", value: 2 },
//                 { label: "Lead 24", value: 3 },
//               ]}
//               value={selectedLeads}
//               onChange={(value) => setSelectedLeads(value)}
//             />
//           </div>
//           {selectedLeads.length >= 2 && (
//             <>
//               <hr className="text-gray-200" />

//               <div className="flex gap-5">
//                 <Chip
//                   label="RA_lead261357653"
//                   variant="outlined"
//                   icon={"close"}
//                   iconPosition="after"
//                   className="bg-gray-100 !text-info-300 !border-gray-300"
//                 />
//                 <Chip
//                   label="RA_lead9658573"
//                   variant="outlined"
//                   icon={"close"}
//                   iconPosition="after"
//                   className="bg-gray-100 !text-info-300 !border-gray-300"
//                 />
//               </div>
//             </>
//           )}
//           <div className="flex justify-end gap-2">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               size="sm"
//               disabled={selectedLeads.length < 2}
//             />
//             <Button
//               title={"Next"}
//               size="sm"
//               disabled={selectedLeads.length < 2}
//               onClick={() => navigate("/ats/leads/merge-leads")}
//             />
//           </div>
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default AllLeads;

// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Drawer,
//   FormFieldSet,
//   InfoCardNew,
//   NewTableAdv,
//   Chip,
// } from "../../../../components";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllLeadsStart } from "../../../../redux/slices/leads/leadsSlice";
// import { mapTableRows } from "../../../../utils";
// import { useNavigate } from "react-router-dom";

// const AllLeads = () => {
//   const [showMergeModal, setShowMergeModal] = useState(false);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { allLeads, loading } = useSelector((state) => state?.leads || {});

//   // ✅ Fetch All Leads on mount
//   useEffect(() => {
//     dispatch(
//       fetchAllLeadsStart({
//         coll: "Company",
//         fil: JSON.stringify({
//           uiid: { type: "ALL_LEADS", value: "" },
//         }),
//         useAggregate: true,
//         lim: 10,
//         pg: 1,
//         onSuccess: (data) => console.log("✅ All Leads API Data:", data),
//         onError: (err) => console.error("❌ Error fetching leads:", err),
//       })
//     );
//   }, [dispatch]);

//   // ✅ Table Columns
//   const columns = [
//     {
//       key: "name",
//       label: "Account Name",
//       minWidth: 250,
//       render: (row) => (
//         <div className="text-info cursor-pointer">{row?.name || "-"}</div>
//       ),
//     },
//     {
//       key: "jobTitle",
//       label: "Job Title",
//       width: 250,
//       render: (row) => (row.jobIds?.length ? row.latestJob?.title || "-" : "-"),
//     },
//     {
//       key: "jobLocation",
//       label: "Job Location",
//       width: 250,
//       render: (row) =>
//         row.jobIds?.length
//           ? `${row.latestJob?.location?.city || "-"}, ${
//               row.latestJob?.location?.state || "-"
//             }, ${row.latestJob?.location?.country || "-"}`
//           : "-",
//     },
//     {
//       key: "website",
//       label: "Website",
//       minWidth: 300,
//       render: (row) =>
//         row.jobIds?.length ? (
//           <a
//             href={row.latestJob?.description || row.website || "#"}
//             target="_blank"
//             rel="noreferrer"
//             className="text-info underline"
//           >
//             {row.website || row.latestJob?.description || "-"}
//           </a>
//         ) : (
//           "-"
//         ),
//     },
//     {
//       key: "prospectsCount",
//       label: "Prospects",
//       width: 100,
//       render: (row) => (
//         <div className="text-success font-semibold">
//           {row.prospectsCount || 0}/5
//         </div>
//       ),
//     },
//   ];

//   // ✅ Map rows safely
//   const rows = allLeads?.data || [];
//   const mappedRows = mapTableRows(rows, columns);

//   return (
//     <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-8 gap-10 px-4">
//         <InfoCardNew title="Total Accounts" value={rows.length || 0} />
//         <InfoCardNew title="Completed Accounts" value={12} backValue={-21} />
//         <InfoCardNew title="Pending Accounts" value={7777} backValue={21} />
//         <InfoCardNew title="Total Job Details" value={12} backValue={-21} />
//         <InfoCardNew title="Total Contact Details" value={24} backValue={21} />
//         <InfoCardNew title="Valid Emails" value={12} backValue={-21} />
//         <InfoCardNew title="Invalid Emails" value={24} backValue={21} />
//         <InfoCardNew title="Yet To Validate Emails" value={12} backValue={21} />
//       </div>

//       {/* Leads Table */}
//       <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
//         <div className="flex-1 overflow-hidden shadow-tableset px-2">
//           <NewTableAdv
//             columns={columns}
//             rows={mappedRows}
//             loading={loading}
//             toolbarRight={{
//               search: true,
//               filter: true,
//               download: false,
//               add: [
//                 {
//                   component: (
//                     <div className="flex gap-3">
//                       <Button
//                         title="Merge Lead"
//                         icon={"cell_merge"}
//                         size="sm"
//                         onClick={() => setShowMergeModal(true)}
//                       />
//                     </div>
//                   ),
//                 },
//               ],
//             }}
//           />
//         </div>
//       </div>

//       {/* Merge Drawer */}
//       <Drawer
//         isOpen={showMergeModal}
//         title="Select Lead"
//         onClose={() => setShowMergeModal(false)}
//         width="w-[50%]"
//       >
//         <div className="flex flex-col gap-3">
//           <div className="grid grid-cols-2">
//             <FormFieldSet
//               type="select"
//               multiple
//               showSearch
//               title="Minimum 2 leads are required to merge"
//               placeholder="Search Lead"
//               options={rows.map((r) => ({ label: r.name, value: r._id }))}
//               value={selectedLeads}
//               onChange={(value) => setSelectedLeads(value)}
//             />
//           </div>

//           {selectedLeads.length >= 2 && (
//             <>
//               <hr className="text-gray-200" />
//               <div className="flex gap-5 flex-wrap">
//                 {selectedLeads.map((leadId) => {
//                   const lead = rows.find((r) => r._id === leadId);
//                   return (
//                     <Chip
//                       key={leadId}
//                       label={lead?.name || "Lead"}
//                       variant="outlined"
//                       icon="close"
//                       iconPosition="after"
//                       className="bg-gray-100 !text-info-300 !border-gray-300"
//                     />
//                   );
//                 })}
//               </div>
//             </>
//           )}

//           <div className="flex justify-end gap-2 mt-3">
//             <Button
//               variant="outlined"
//               title="Cancel"
//               size="sm"
//               onClick={() => setShowMergeModal(false)}
//             />
//             <Button
//               title="Next"
//               size="sm"
//               disabled={selectedLeads.length < 2}
//               onClick={() => navigate("/ats/leads/merge-leads")}
//             />
//           </div>
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default AllLeads;

import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Chip,
  Drawer,
  FormFieldSet,
  SmartTooltip,
  LogoLoader,
  Backdrop,
  TableAdv,
  InfoWrapper,
  InfoCardNewAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLeadsStart } from "../../../../redux/slices/leads/leadsSlice";
import { getAllLeadsCountStart } from "../../../../redux/slices/accountDetails/accountDetailsSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../utils/stringUtils";

const AllLeads = () => {
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [counts, setCounts] = useState({
    TotalAccounts: 0,
    completedAccounts: 0,
    pendingAccounts: 0,
    TotalJobs: 0,
    TotalContacts: 0,
    validEmails: 0,
    invalidEmails: 0,
    yetToValidateEmails: 0,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state?.leads);
  const allLeads = useSelector((state) => state?.leads?.allLeads);
  const allLeadsCount = useSelector(
    (state) => state?.accountDetails?.allLeadsCount,
  );
  const allLeadsCountLoading = useSelector(
    (state) => state?.accountDetails?.allLeadsCountLoading,
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.allLeadsTableCount?.data || 0;

  useEffect(() => {
    if (allLeadsCount) {
      setCounts(allLeadsCount);
    }
  }, [allLeadsCount]);

  const fetchJobsSearch = () => {
    dispatch(
      fetchAllLeadsStart({
        coll: "Job",
        fil: JSON.stringify({
          uiid: { type: "ALL_LEADS_SEARCH", value: searchValue.trim() },
        }),
        useAggregate: true,
        lim: limit,
        pg: page,
        sort: { addedOn: -1 },
        onSuccess: (data) => {
          // console.log("All Leads API Data:", data);
        },
      }),
    );
    dispatch(
      totalCountStart({
        collection: "jobs",
        coll: "Job",
        tname: "allLeadsTableCount",
        filters: {
          uiid: { type: "ALL_LEADS_SEARCH_COUNT", value: searchValue.trim() },
        },
        useAggregate: true,
        app: "ats",
      }),
    );
  };

  const fetchAllData = async () => {
    try {
      dispatch(
        fetchAllLeadsStart({
          coll: "Job",
          fil: JSON.stringify({
            uiid: { type: "ALL_LEADS", value: "" },
          }),
          useAggregate: true,
          lim: limit,
          pg: page,
          sort: { addedOn: -1 },
          onSuccess: (data) => {
            // console.log("All Leads API Data:", data);
          },
        }),
      );

      dispatch(
        totalCountStart({
          collection: "jobs",
          coll: "Job",
          tname: "allLeadsTableCount",
          filters: {
            uiid: { type: "ALL_LEADS", value: "" },
          },
          app: "ats",
        }),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debounceRef = useRef(null);
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    if (searchValue.trim().length <= 1) {
      return;
    }
    debounceRef.current = setTimeout(() => {
      setPage(1);
      fetchJobsSearch();
    }, 500);

    //setTotalCount(value?.allJobsPosts?.data || 0)

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchValue]);

  useEffect(() => {
    if (searchValue.trim().length > 1) {
      fetchJobsSearch();
    } else {
      fetchAllData();
    }
  }, [dispatch, limit, page]);
  useEffect(() => {
    dispatch(
      getAllLeadsCountStart({
        coll: "SystemStat",
        fil: {
          type: {
            type: "NONE",
            value: "companyStats",
          },
        },
        lim: 10,
        pg: 1,
      }),
    );
  }, []);

  const columns = [
    {
      key: "companyName",
      label: "Account Name",
      minWidth: 50,
      render: (row) => (
        <div className="text-info cursor-pointer">
          {formatWords2(row.companyName)}
        </div>
      ),
    },
    { key: "jobTitle", label: "Job Title", minWidth: 150 },
    { key: "jobLocation", label: "Job Location", minWidth: 250 },
    {
      key: "jobDescription",
      label: "Job Description",
      minWidth: 150,
      className: "flex-1",
      render: (row) => {
        const link = row.jobDescription;

        // Conditions for disabling link
        const isValidLink =
          link &&
          link !== "_" &&
          typeof link === "string" &&
          link.trim() !== "";

        return (
          <div className="flex-1 flex text-info items-center gap-2">
            {isValidLink ? (
              <a
                href={link}
                target="_blank"
                className=" text-blue-600 hover:underline cursor-pointer"
                rel="noreferrer"
              >
                Link
              </a>
            ) : (
              <span className="text-gray-400">_</span>
            )}
          </div>
        );
      },
    },
    {
      key: "contactDetails",
      label: "Contact Details",
      maxWidth: 170,
      render: (row) => (
        <div className="flex-1 flex items-center gap-2">
          <div className="w-fit truncate overflow-hidden whitespace-nowrap">
            <span className="text-success">{row.contactCount}</span>/5
          </div>
        </div>
      ),
    },
    {
      key: "",
      label: "Actions",
      minWidth: 100,
      render: (row) => (
        <div className="flex items-center justify-between gap-2">
          <SmartTooltip description={"View"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="visibility"
              size="xs"
              color="black"
              onClick={() => {
                console.log("View:", row);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description={"Edit"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="edit_square"
              size="xs"
              color="black"
              onClick={() => console.log("Edit:", row)}
            />
          </SmartTooltip>
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              size="xs"
              color="black"
              onClick={() => console.log("Delete:", row)}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const rows =
    allLeads?.data?.map((job) => {
      const company = job.companyId || {};

      return {
        companyName: company.name || "-",

        jobTitle: formatWords2(job.title || "-"),

        jobLocation:
          [
            job?.location?.city,
            job?.location?.state,
            job?.location?.country,
          ]
            .filter(Boolean)
            .join(", ") || "_", 

        jobDescription: job.description || "_",

        contactCount: job.prospectIds?.length || 0,
      };
    }) || [];

  const mappedRows = mapTableRows(rows, columns);

  return (
    <div className="flex flex-col mt-5 flex-1 overflow-hidden">
      <InfoWrapper>
        <InfoCardNewAdv
          title="Total Accounts"
          value={counts.totalAccounts}
          //backValue={21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Completed Accounts"
          value={counts.completedAccounts}
          //backValue={-21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Pending Accounts"
          value={counts.pendingAccounts}
          //backValue={21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Total Job Details"
          value={counts.totalJobDetails}
          //backValue={-21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Total Contact Details"
          value={counts.totalContacts}
          //backValue={21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Valid Emails"
          value={counts.validEmails}
          //backValue={-21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Invalid Emails"
          value={counts.invalidEmails}
          //backValue={21}
          isLoading={allLeadsCountLoading}
        />
        <InfoCardNewAdv
          title="Yet To Validate Emails"
          value={counts.yetToValidateEmails}
          //backValue={21}
          isLoading={allLeadsCountLoading}
        />
      </InfoWrapper>

      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        {/* <div className="flex-1 overflow-hidden shadow-tableset px-2"> */}
        <TableAdv
          tableId={"ats_leads_allleads_table"}
          showSlNo
          columns={columns}
          rows={mappedRows}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          isLoading={loading}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          serverOnSearch={(key, value) => {
            setSearchValue(value);
            setPage(1);
            handleLimitChange(25);
            if (!value) {
              setPage(1);
              fetchAllData();
            }
          }}
          toolbarRight={{
            search: true,
            // filter: true,
            fullScreen: true,
            download: false,
            add: [
              {
                component: (
                  <div className="flex gap-3">
                    <div className="flex justify-end items-end">
                      <Button
                        title="Merge Lead"
                        icon={"cell_merge"}
                        size="sm"
                        onClick={() => setShowMergeModal(true)}
                      />
                    </div>
                  </div>
                ),
              },
            ],
          }}
        />
        {/* </div> */}
      </div>

      <Drawer
        isOpen={showMergeModal}
        title={"Select Lead"}
        onClose={() => setShowMergeModal(false)}
        width="w-[50%]"
      >
        <div className="flex flex-col gap-3">
          <div className="grid grid-cols-2">
            <FormFieldSet
              // type="select"
              type="allCompanies"
              multiple
              showSearch
              title="Minimum 2 leads are required to merge"
              placeholder="Search Lead"
              options={[{ label: "Lead 1", value: 1 }]}
              value={selectedLeads}
              onChange={(value) => setSelectedLeads(value)}
            />
          </div>

          {selectedLeads.length >= 2 && (
            <>
              <hr className="text-gray-200" />
              <div className="flex gap-5">
                {selectedLeads.map((lead, idx) => (
                  <Chip
                    key={idx}
                    label={`RA_lead${lead}`}
                    variant="outlined"
                    icon={"close"}
                    iconPosition="after"
                    className="bg-gray-100 !text-info-300 !border-gray-300"
                  />
                ))}
              </div>
            </>
          )}
          <div className="flex justify-end gap-2">
            <Button
              variant="outlined"
              title={"Cancel"}
              size="sm"
              disabled={selectedLeads.length < 2}
              onClick={() => setShowMergeModal(false)}
            />
            <Button
              title={"Next"}
              size="sm"
              disabled={selectedLeads.length < 2}
              onClick={() =>
                navigate("/ats/leads/merge-leads", { state: { selectedLeads } })
              }
            />
          </div>
        </div>
      </Drawer>
      {/* <Backdrop isOpen={loading} zIndex={51}>
        <LogoLoader />
      </Backdrop> */}
    </div>
  );
};

export default AllLeads;
